// @flow
import DishesKit from './DishesKit';
import DishesKitTableHeader from './DishesKitTableHeader';

export default DishesKit;
export { DishesKitTableHeader };
